export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "coinhero-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "coinhero-themeWrapLive" */'./LiveThemeImporter'),
  },
};
